<mat-toolbar class="main-header">
  @if (sidenav.mode === "over" && isMe) {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon>menu</mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon>close</mat-icon>
      }
    </button>
  }
  @if (!isMe && user) {
    <button
      mat-icon-button
      (click)="goBack()"
      aria-label="Volver a la clasificación"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
  }
  <span>{{ title }}</span>
  <span class="spacer"></span>
  <mat-icon (click)="showRules()">help</mat-icon>
</mat-toolbar>

<div class="home-wrapper">
  <!-- ── Hero ─────────────────────────────────────────────── -->
  <div class="hero">
    <div class="hero-bg"></div>
    <div class="hero-content">
      <div class="avatar-ring">
        <app-avatar [user]="user"></app-avatar>
      </div>
      <h1 class="hero-name">{{ user?.name || user?.email }}</h1>
      @if (standings) {
        <span class="hero-rank">
          <mat-icon>emoji_events</mat-icon>
          {{ standings.pos }}ª posición
        </span>
      }
      <button class="hero-standings-btn" (click)="showStandings()">
        <mat-icon>format_list_numbered</mat-icon>
        Ver clasificación
      </button>
    </div>
  </div>

  <!-- ── Body ─────────────────────────────────────────────── -->
  <div class="home-body">
    @if (isMe && pendingPredictions > 0) {
      <button class="today-action" (click)="showPoll()">
        <span class="today-action__icon"><mat-icon>edit_calendar</mat-icon></span>
        <span class="today-action__copy">
          <strong>Completa {{ pendingPredictions }} pronósticos</strong>
          <span>{{ pendingRoundTitle }} todavía está abierta</span>
        </span>
        <mat-icon>chevron_right</mat-icon>
      </button>
    }

    @if (isMe && nextMatches.length > 0) {
      <div class="section-label">Próximos partidos</div>
      <div class="next-matches">
        @for (match of nextMatches; track match._id) {
          <div class="next-match">
            <span>{{ match.date | date: "EEE d, HH:mm" }}</span>
            <strong>{{ match.homeTeam?.name }} · {{ match.awayTeam?.name }}</strong>
          </div>
        }
      </div>
    }

    @if (isMe && latestMatchDaySummary?.data) {
      <div class="section-label">Última jornada</div>
      <article class="matchday-summary">
        <div class="matchday-summary__head">
          <div>
            <span>{{ latestMatchDaySummary.title }}</span>
            <h2>{{ latestMatchDaySummary.data.narrative?.headline || "Resultado de jornada" }}</h2>
          </div>
          <button type="button" (click)="shareMatchDay(latestMatchDaySummary)" aria-label="Compartir resultado">
            <mat-icon>ios_share</mat-icon>
          </button>
        </div>
        <div class="matchday-podium">
          @for (entry of latestMatchDaySummary.data.topMovers?.slice(0, 3); track entry.userId; let i = $index) {
            <div>
              <span>{{ i + 1 }}º</span>
              <strong>{{ entry.userName }}</strong>
              <b>{{ entry.roundPoints }} pts</b>
            </div>
          }
        </div>
        @if (latestMatchDaySummary.data.narrative?.intro) {
          <p>{{ latestMatchDaySummary.data.narrative.intro }}</p>
        }
        <button
          mat-stroked-button
          class="summary-read-more"
          type="button"
          (click)="openMatchDaySummary(latestMatchDaySummary)"
        >
          <mat-icon>auto_stories</mat-icon>
          Abrir crónica completa
        </button>
      </article>
    }

    @if (isMe && latestGroupSummaries.length > 0) {
      <div class="section-label">Última jornada en tus grupos</div>
      <div class="group-summary-list">
        @for (summary of latestGroupSummaries; track summary.groupId) {
          <article class="matchday-summary matchday-summary--group">
            <div class="matchday-summary__head">
              <div>
                <span>
                  {{ summary.group?.shield || "🏆" }}
                  {{ summary.group?.name || "Grupo" }}
                </span>
                <h2>
                  {{
                    summary.data?.narrative?.headline ||
                      summary.title ||
                      "Resultado de jornada"
                  }}
                </h2>
              </div>
              <button
                type="button"
                (click)="shareMatchDay(summary)"
                aria-label="Compartir resultado del grupo"
              >
                <mat-icon>ios_share</mat-icon>
              </button>
            </div>
            <div class="matchday-podium">
              @for (
                entry of summary.data?.topMovers?.slice(0, 3);
                track entry.userId;
                let i = $index
              ) {
                <div>
                  <span>{{ i + 1 }}º</span>
                  <strong>{{ entry.userName }}</strong>
                  <b>{{ entry.roundPoints }} pts</b>
                </div>
              }
            </div>
            @if (summary.data?.narrative?.intro) {
              <p>{{ summary.data.narrative.intro }}</p>
            }
            <button
              mat-stroked-button
              class="summary-read-more"
              type="button"
              (click)="openMatchDaySummary(summary)"
            >
              <mat-icon>auto_stories</mat-icon>
              Abrir crónica completa
            </button>
          </article>
        }
      </div>
    }

    @if (isMe && activities.length > 0) {
      <div class="section-label">Actividad</div>
      <div class="activity-feed">
        @for (activity of visibleActivities; track activity._id) {
          <article class="activity-card">
            <div class="activity-card__icon">
              @switch (activity.type) {
                @case ("badge_unlocked") { {{ activity.metadata?.badgeIcon || "🏅" }} }
                @case ("match_day_summary") { 🏆 }
                @default { 💬 }
              }
            </div>
            <div class="activity-card__body">
              <div class="activity-card__header">
                <div>
                  <strong>{{ activity.message }}</strong>
                  <span>{{ activity.createdAt | date: "d MMM, HH:mm" }}</span>
                </div>
                <button
                  type="button"
                  mat-button
                  (click)="archiveActivity(activity)"
                  aria-label="Archivar actividad"
                  title="Archivar"
                >
                  <mat-icon>visibility_off</mat-icon>
                  <span>Ocultar</span>
                </button>
              </div>
              @if (
                activity.type === "group_post" &&
                activity.metadata?.postMessage
              ) {
                <blockquote class="activity-post-message">
                  {{ activity.metadata.postMessage }}
                </blockquote>
              }
              <div class="activity-reactions">
                @for (emoji of activityEmojis; track emoji) {
                  <button type="button" (click)="reactToActivity(activity, emoji)">
                    {{ emoji }} {{ reactionCount(activity, emoji) || "" }}
                  </button>
                }
              </div>
              @for (comment of activity.comments?.slice(-2); track comment._id || $index) {
                <p class="activity-comment">
                  <b>{{ comment.userId?.name }}:</b> {{ comment.message }}
                </p>
              }
              <div class="activity-comment-box">
                <input
                  [(ngModel)]="activityComments[activity._id]"
                  maxlength="240"
                  placeholder="Comentar..."
                  (keyup.enter)="commentOnActivity(activity)"
                />
                <button type="button" (click)="commentOnActivity(activity)">
                  <mat-icon>send</mat-icon>
                </button>
              </div>
            </div>
          </article>
        }
      </div>
      @if (activities.length > 3) {
        <button
          type="button"
          class="activity-toggle"
          (click)="toggleActivities()"
        >
          {{
            activityLimit === 3
              ? "Ver más actividad"
              : "Mostrar menos"
          }}
          <mat-icon>
            {{ activityLimit === 3 ? "expand_more" : "expand_less" }}
          </mat-icon>
        </button>
      }
    }

    <!-- Stats -->
    <div class="stats-row" (click)="showPoll()">
      <div class="stat-item">
        <span class="stat-value">{{ standings?.points }}</span>
        <span class="stat-label">Puntos</span>
      </div>
      <div class="stat-divider"></div>
      <div class="stat-item">
        <span class="stat-value">{{ standings?.matchesOk }}</span>
        <span class="stat-label">Aciertos</span>
      </div>
      <div class="stat-divider"></div>
      <div class="stat-item">
        <span class="stat-value">{{ standings?.sniper }}</span>
        <span class="stat-label">Dianas</span>
      </div>
    </div>

    <div class="section-label">Evolución en la clasificación</div>
    <div class="evolution-block">
      <app-standings-evolution-chart
        [title]="'Tu posición jornada a jornada'"
        [labels]="evolutionLabels"
        [series]="evolutionSeries"
        [yAxisMode]="'position'"
        [groups]="evolutionGroups"
        [selectedGroup]="evolutionGroupSelected"
        [showLegend]="false"
        (selectedGroupChange)="selectEvolutionGroup($event)"
      ></app-standings-evolution-chart>
    </div>

    <div class="section-label">Insignias Scout</div>
    @if (isMe && nextBadge; as badge) {
      <div class="badge-progress-card">
        <span class="badge-progress-card__icon">{{ badge.icon }}</span>
        <div class="badge-progress-card__copy">
          <span>Próxima insignia</span>
          <strong>{{ badge.title }}</strong>
          <div class="badge-progress-track">
            <i [style.width.%]="badge.progress?.percentage || 0"></i>
          </div>
          <small>{{ badge.progress?.label }}</small>
        </div>
      </div>
    }
    <div class="badges-row">
      @for (badge of homeBadges; track badge.id) {
        <div
          class="badge-chip"
          [class.badge-chip--locked]="!badge.unlocked"
          [class.badge-chip--new]="isRecentlyUnlocked(badge.id)"
          [class.badge-chip--gold]="badge.tier === 'gold'"
          [class.badge-chip--silver]="badge.tier === 'silver'"
          [class.badge-chip--bronze]="badge.tier === 'bronze'"
          (click)="badge.unlocked && shareBadge(badge)"
        >
          <span class="badge-icon">{{ badge.icon }}</span>
          <span class="badge-name">{{ badge.title }}</span>
        </div>
      }
    </div>
    <button class="badges-toggle" (click)="openBadgeBook()">
      Abrir Libro Scout ({{ unlockedBadgesCount }}/{{ badges.length }})
    </button>

    @if (isMe && groupPositions.length > 0) {
      <div class="section-label">Mis grupos</div>
      <div class="home-groups">
        @for (item of groupPositions; track item.group._id) {
          <article class="home-group" (click)="showGroup(item.group._id)">
            <span class="home-group__shield">{{ item.group.shield || "🏆" }}</span>
            <div>
              <strong>{{ item.group.name }}</strong>
              <span>{{ item.position }}ª posición · {{ item.points }} pts</span>
            </div>
            <button type="button" (click)="shareGroupPosition(item); $event.stopPropagation()">
              <mat-icon>ios_share</mat-icon>
            </button>
          </article>
        }
      </div>
    }

    @if (user) {
      <!-- Predictions card -->
      <div class="section-label">Pronósticos especiales</div>
      <div class="predictions-card" (click)="showPoll()">
        <!-- Champion -->
        <div class="prediction-item">
          <span class="prediction-tag">Campeón</span>
          @if (isMe || isAdmin || currentTimestamp >= firstRoundIniTimestamp) {
            <div class="prediction-flag">
              @if (user.champion) {
                <img [src]="user.champion.flag" [alt]="user.champion.name" />
              } @else {
                <img src="assets/imgs/logo.png" alt="Sin seleccionar" />
              }
              @if (user.champion?._id === finalResult?.team._id) {
                <span class="check-badge"
                  ><mat-icon>check_circle</mat-icon></span
                >
              }
            </div>
            <span class="prediction-name">
              @if (user.champion) {
                {{ user.champion.name }}
              } @else if (isMe) {
                <span
                  class="configure-hint"
                  (click)="showChampion(); $event.stopPropagation()"
                  >Configurar</span
                >
              } @else {
                —
              }
            </span>
          } @else {
            <div class="prediction-flag locked">
              <img src="assets/imgs/logo.png" alt="" />
            </div>
            <span class="prediction-name muted">¡Espera al inicio!</span>
          }
        </div>

        <div class="pred-divider"></div>

        <!-- Pichichi -->
        <div class="prediction-item">
          <span class="prediction-tag">Pichichi</span>
          @if (isMe || isAdmin || currentTimestamp >= firstRoundIniTimestamp) {
            <div class="prediction-flag">
              @if (pichiciPlayer?.team?.flag) {
                <img
                  [src]="pichiciPlayer.team.flag"
                  [alt]="pichiciPlayer.team.name"
                />
              } @else {
                <img src="assets/imgs/pichichi.png" alt="Pichichi" />
              }
              @if (user?.pichichi && user?.pichichi === finalResult?.pichichi) {
                <span class="check-badge"
                  ><mat-icon>check_circle</mat-icon></span
                >
              }
            </div>
            <span class="prediction-name">
              @if (pichiciPlayer) {
                {{ pichiciPlayer.name }}
              } @else if (isMe) {
                <span
                  class="configure-hint"
                  (click)="showChampion(); $event.stopPropagation()"
                  >Configurar</span
                >
              } @else {
                —
              }
            </span>
          } @else {
            <div class="prediction-flag locked">
              <img src="assets/imgs/pichichi.png" alt="" />
            </div>
            <span class="prediction-name muted">¡Espera al inicio!</span>
          }
        </div>
      </div>

      <!-- CTA -->
      <button class="cta-btn" (click)="showPoll()">
        <mat-icon>bar_chart</mat-icon>
        Ver todos los resultados
      </button>
    }
  </div>
</div>
